import React from 'react';
import PropTypes from 'prop-types';

import OrganizationItemChildrenTree from './chatOrganizationItemChildrenTree';
import OrganizationItemContent from './chatOrganizationItemContent';

function ChatOrganizationItem({
  selectedsOrganizations,
  organization: organizationItem,
  handleSelectOrganization,
  handleClickOrganization,
  isActive
}) {
  const { organization, childOrganizations } = organizationItem;

  return (
    <div
      data-testid={`organization-item-${organization.key}`}
      key={organization.id}
      className="org-list-item"
    >
      <OrganizationItemContent
        organization={organization}
        childOrganizations={childOrganizations}
        showRightIcon
        selectedsOrganizations={selectedsOrganizations}
        isActive={isActive}
        handleClickOrganization={handleClickOrganization}
        handleSelectOrganization={handleSelectOrganization}
      />
      {(isActive(organization) && childOrganizations) && (
        <OrganizationItemChildrenTree
          testid={`organization-item-children-tree-${organization.key}`}
          className="organization-item-children-tree"
          key={organization.id}
          childOrganizations={childOrganizations}
          selectedsOrganizations={selectedsOrganizations}
          isActive={isActive}
          handleSelectOrganization={handleSelectOrganization}
          handleClickOrganization={handleClickOrganization}
        />
      )}
    </div>
  );
}

ChatOrganizationItem.propTypes = {
  selectedsOrganizations: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired,
  handleSelectOrganization: PropTypes.func.isRequired,
  handleClickOrganization: PropTypes.func.isRequired,
  isActive: PropTypes.func.isRequired
};

export default ChatOrganizationItem;
